<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="this.$t('menu.register')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="main-content">
      <!-- <div class="topList">
        <div class="list">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="item"
            v-on:click="onClickItem(index)"
          >
            <label
                class="title"
                v-bind:class="{active: index === currentIndex,normal: index !== currentIndex}"
            >
              {{ getTitle(item) }}</label>
            <div v-if="isShowLine(index)" class="line"></div>
          </div>
        </div>
      </div>
      <flex-line v-if="inviter" :show-border="true"><span class="line-name">{{ $t('register.inviter') }}</span><span slot="right">{{inviter.member_name}}</span></flex-line> -->
      <!-- login logo -->
      <div style="display: flex; justify-content: center; margin: 60px 0px 25px;">
        <img src="@/assets/image/login_logo.svg" style="width: 50%" />
      </div>
      <register-by-mobile/>
    </div>
  </div>
</template>

<script>
import RegisterByMobile from './RegisterByMobile'
import { mapState } from 'vuex'
import { getInviterInfo } from '../../../api/memberRegister'
import flexLine from '../../flexLine'

export default {
  name: 'Register',
  components: {
    flexLine,
    RegisterByMobile
  },
  data () {
    return {
      inviter: false,
      currentIndex: 0,
      items: [
        {
          id: 1,
          title: this.$t('register.register_by_mobile')
        }
      ]
    }
  },
  created: function () {
    if (this.inviter_id) {
      getInviterInfo(this.inviter_id).then(res => {
        this.inviter = res.result.member
      })
    }
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    }),
    isFirstTab () {
      if (this.currentIndex === 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {

    goBack () {
      this.$router.go(-1)
    },
    getTitle (item) {
      return item ? item.title : ''
    },
    isShowLine (index) {
      return index === this.currentIndex
    },
    onClickItem (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  //background-color: #fa800a;
  .main-content{
    // background: #fff;
    padding: 0;
  }
}
.common-header {
  height: 4rem;
  line-height: 4rem;
  border-radius: 0px 0px 30px 30px;
  background: #f4c41e;
}

.topList {
  height: 2rem;
  padding-top: 1rem;
  // padding:1rem $pageSpace;
  // border-bottom: 1px solid #e8eaed;

  .list {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: stretch;
    background-color: #f5f5f5;
  }

  .item {
   padding:0 .5rem;
   position: relative;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
  }

  .title {
    font-size: 0.7rem;
    color: black;
    text-align: center;
  //  font-size:$h2;
  //  color: $formInputColor;
  }

  .active {
    // color: $primaryColor;
    color: black
    // font-size:1.1rem;
  }

  .normal {
    color: #404245;
  }

  .line {
    position: absolute;
    left: 2.5rem;
    right: 2.5rem;
    bottom: 0;
    height: 0.1rem;
    background-color: #fa800a;
  }
}
</style>
